import { render, staticRenderFns } from "./relatedCompanies.vue?vue&type=template&id=123966ab&scoped=true&"
import script from "./relatedCompanies.vue?vue&type=script&lang=js&"
export * from "./relatedCompanies.vue?vue&type=script&lang=js&"
import style0 from "./relatedCompanies.vue?vue&type=style&index=0&id=123966ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123966ab",
  null
  
)

export default component.exports